import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsanaMarketService } from '@usana/ux/markets';
import { UniversalModalModule } from '@usana/ux/universal-components/modal';

export interface ChooseLocaleModalData {
  markets: any[];
  currentMarketLocale: any;
}

@Component({
  selector: 'u-choose-locale-modal',
  standalone: true,
  imports: [CommonModule, UniversalModalModule, FaIconComponent],
  templateUrl: './choose-locale-modal.component.html',
  styleUrls: ['./choose-locale-modal.component.scss'],
})
export class ChooseLocaleModalComponent {
  private readonly modal = inject(NgbActiveModal);
  private readonly usanaMarketService = inject(UsanaMarketService);

  data: ChooseLocaleModalData;

  readonly selectedMarket = signal<any>(null);
  readonly showLanguages = signal(false);

  selectMarket(market: any): void {
    if (market.languages && market.languages.length > 1) {
      this.selectedMarket.set(market);
      this.showLanguages.set(true);
    } else if (market.languages && market.languages.length === 1) {
      this.setLocale(market.languages[0].locale);
    }
  }

  backToMarkets(): void {
    this.showLanguages.set(false);
    this.selectedMarket.set(null);
  }

  setLocale(locale: string): void {
    this.usanaMarketService.setMarketId(locale);
    this.modal.close();
  }

  close(): void {
    this.modal.close();
  }
}
